import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BibliothequesService } from 'src/services/bibliotheques.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-delete-bibliotheque-dialog',
    imports: [MatDialogModule, TranslateModule],
    templateUrl: './delete-bibliotheque-dialog.component.html',
    styleUrls: ['./delete-bibliotheque-dialog.component.scss']
})
export class DeleteBibliothequeDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DeleteBibliothequeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { bibliothequeId: number },
    private bibliothequesService: BibliothequesService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) { }

  confirmerSuppression(): void {
    this.bibliothequesService.supprimerBibliotheque(this.data.bibliothequeId).subscribe({
      next: () => {
        this.translateService.get('LIBRARIES_MANAGEMENT.DELETION_SUCCESSFUL').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(true);
      },
      error: () => {
        this.translateService.get('LIBRARIES_MANAGEMENT.DELETION_ERROR').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(false);
      }
    });
  }

  annuler(): void {
    this.dialogRef.close(false);
  }
}
